export default __webpack_public_path__ + "static/media/me.dd4c0296.svg";